import axios from 'axios';
import { isTokenExpired, refreshToken } from '../services/authService';
import { removeRefreshToken } from '../utils/cookieUtils';

const axiosInstance = axios.create({
    // Use relative URLs - will go through proxy in both dev and prod
    baseURL: '',
});

axiosInstance.interceptors.request.use(
    async (config) => {
      let token = localStorage.getItem('access_token');
  
      if (token && isTokenExpired(token)) {
        token = await refreshToken();
      }
  
      if (token && !isTokenExpired(token)) {
        config.headers.Authorization = `Bearer ${token}`;
      }
  
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  
  axiosInstance.interceptors.response.use(
    (res) => res,
    async (err) => {
      const originalRequest = err.config;
  
      if (err.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
  
        const newToken = await refreshToken();
  
        if (newToken) {
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return axiosInstance(originalRequest);
        } else {
          localStorage.removeItem('access_token');
          removeRefreshToken(); // Now using cookie utility
          window.location.href = '/login';
        }
      }
      return Promise.reject(err);
    }
  );
  
  export default axiosInstance;